module.exports = __webpack_public_path__ + "static/media/home-icon.06037f09.png";